$(() => {
  $('.move-lower').on('click', function () {
    const myPosition = $(this)
      .parents('li')
      .children('input[id^="attachment_position_"]')
      .val();
    if ($(this).parents('li').nextAll('li').has('div:visible').length) {
      const nextPosition = $(this)
        .parents('li')
        .nextAll('li')
        .has('div:visible')
        .first()
        .children('input[id^="attachment_position_"]')
        .val();
      $(this)
        .parents('li')
        .children('input[id^="attachment_position_"]')
        .val(nextPosition);
      $(this)
        .parents('li')
        .nextAll('li')
        .has('div:visible')
        .first()
        .children('input[id^="attachment_position_"]')
        .val(myPosition);
      $(this)
        .parents('li')
        .nextAll('li')
        .has('div:visible')
        .first()
        .insertBefore($(this).parents('li'));
    }
  });
});
